export default "__VITE_ASSET__CXpXV_Of__"